import { defineMessages } from 'react-intl';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closedOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	closesOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-deal.deal-label',
		defaultMessage: 'Deal',
		description:
			'Badge label shown on a deal search result card to identify the result type as a CRM deal.',
	},
	closedOn: {
		id: 'search-graph-deal.closed-on',
		defaultMessage: 'Closed on {date}',
		description:
			'Metadata text shown on a deal search result card indicating when the deal was closed. The placeholder {date} is substituted with the formatted closing date.',
	},
	closesOn: {
		id: 'search-graph-deal.closes-on',
		defaultMessage: 'Closes on {date}',
		description: 'Future date when the deal is expected to close',
	},
});
